import { createApi, fetchData, deleteApi, getApi, updateApi, uploadApi } from '@/lib/api.service.js'

const currentUrl = `${import.meta.env.VITE_BACKEND_URL}/api/v2/servicechek/user_vehicles`;

export async function indexUserVehicles(params = null) {
  try {
    return await fetchData(currentUrl, params);
  } catch (e) {
    console.error(e);
    throw e;
  }
}

export async function getUserVehicle(id){
  try {
    let url = `${currentUrl}/${id}`;
    const response = await getApi(url);

    if (response.status >= 200 && response.status < 300) {
      return response.json
    } else {
      throw new Error(response.json.error);
    }
  } catch (e) {
    console.error(e);
    throw e;
  }
}

export async function createUserVehicle(data) {
  data = { servicechek_user_vehicle: data };

  try {
    const response = await createApi(currentUrl, data);

    if (response.status >= 200 && response.status < 300) {
      return response.json
    } else {
      throw new Error(response.json.error);
    }
  } catch (e) {
    console.error(e);
    throw e;
  }
}

export async function updateUserVehicle(id, data) {
  data = { servicechek_user_vehicle: data };

  try {
    let url = `${currentUrl}/${id}`;
    const response = await updateApi(url, data);

    if (response.status >= 200 && response.status < 300) {
      return response.json
    } else {
      throw new Error(response.json.error);
    }
  } catch (e) {
    console.error(e);
    throw e;
  }
}

export async function deleteUserVehicle(id) {
  try {
    let url = `${currentUrl}/${id}`;
    return await deleteApi(url);
  } catch (e) {
    console.error(e);
    throw e;
  }
}

export async function uploadImage(id, image) {
  let formData = new FormData();
  formData.append('servicechek_user_vehicle[image]', image);

  try {
    let url = `${currentUrl}/${id}`;
    const response = await uploadApi(url, formData);

    if (response.status >= 200 && response.status < 300) {
      return response.json
    } else {
      throw new Error(response.json.error);
    }
  } catch (e) {
    console.error(e);
    throw e;
  }
}